import { AmountEnum } from '@insurance/api/requests'
import { useValidationsField } from '@insurance/hooks'
import { DEFAULT_CURRENCY } from '@shared/constants'
import { Col, Form, Input, Row, Select } from 'antd'
import { useTranslation } from 'react-i18next'

import { formProps } from './utils'

export const InsuranceMiniAmount = () => {
  const { t } = useTranslation()
  const { required } = useValidationsField()
  const { insuredMiniAmountProps } = formProps(t)

  const options = Object.values(AmountEnum)
    .filter((value) => typeof value === 'number')
    .map((value) => ({
      label: value,
      value
    }))

  return (
    <Row gutter={[12, 12]}>
      <Col xs={24} md={12}>
        <Form.Item {...insuredMiniAmountProps} rules={[required]}>
          <Select
            options={options}
            placeholder={insuredMiniAmountProps.label}
          />
        </Form.Item>
      </Col>

      <Col xs={24} md={12}>
        <Form.Item label={t('currency')}>
          <Input
            disabled
            placeholder={t('currency')}
            value={DEFAULT_CURRENCY}
          />
        </Form.Item>
      </Col>
    </Row>
  )
}
